import { IHttpClient, RequestOptionsFactory } from '@wix/http-client';
import { ChatServiceClient } from './ChatServiceClientCore';
import {
  createConversation,
  getConversationMessages,
  getConversationStatus,
  sendMessage,
} from '@wix/ambassador-genie-chat-service-v1-no-entity/http';

const httpClientRequestFactory =
  (httpClient: IHttpClient) =>
  <T>(req: RequestOptionsFactory<T>) =>
    httpClient
      .request(req)
      .then((r) => ({ ...r.data, requestId: r.requestId }));

export class ChatServiceHttpClient extends ChatServiceClient {
  constructor(httpClient: IHttpClient) {
    const _request = httpClientRequestFactory(httpClient);
    super({
      createConversation: (payload) => _request(createConversation(payload)),
      getConversationMessages: (payload) =>
        _request(getConversationMessages(payload)),
      sendMessage: (payload) => _request(sendMessage(payload)),
      getConversationStatus: (payload) =>
        _request(getConversationStatus(payload)),
    });
  }
}
